import Component from "./JumpToFeature";
export default Component;
